import { useState } from "react";

interface VimeoLiteProps {
  vimeoId: string;
  poster: string;
  alt: string;
  /** Start playing on load (muted) and loop continuously, with no click-to-play poster. */
  autoplay?: boolean;
  /** Loop the video continuously. */
  loop?: boolean;
}

export function VimeoLite({ vimeoId, poster, alt, autoplay = false, loop = false }: VimeoLiteProps) {
  const [loaded, setLoaded] = useState(autoplay);

  if (loaded) {
    const params = new URLSearchParams({ autoplay: "1", playsinline: "1" });
    if (loop) params.set("loop", "1");
    // Browsers only permit autoplay-on-load when muted; a click-to-play load keeps sound.
    if (autoplay) params.set("muted", "1");
    return (
      <iframe
        src={`https://player.vimeo.com/video/${vimeoId}?${params.toString()}`}
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        className="w-full aspect-video rounded-lg"
        title={alt}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setLoaded(true)}
      className="relative w-full aspect-video rounded-lg overflow-hidden cursor-pointer group bg-card"
      aria-label={`Play video: ${alt}`}
    >
      <img
        src={poster}
        alt={alt}
        className="w-full h-full object-cover"
        loading="lazy"
        width={1280}
        height={720}
      />
      <div className="absolute inset-0 flex items-center justify-center bg-background/30 group-hover:bg-background/40 transition-colors">
        <svg className="w-20 h-20 text-primary" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M8 5v14l11-7z" />
        </svg>
      </div>
    </button>
  );
}